import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Container from '@material-ui/core/Container';
import Typography from '../components/Typography';

function Copyright() {
  return (
    <React.Fragment>
      {'© '}
      <Link color="inherit" href="https://material-ui.com/">
        SarasaSevillano.com.ar
      </Link>{' '}
      {new Date().getFullYear()}
    </React.Fragment>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.secondary.light,
  },
  container: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    display: 'flex',
  },
  iconsWrapper: {
    height: 120,
  },
  icons: {
    display: 'flex',
  },
  icon: {
    width: 48,
    height: 48,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.warning.main,
    marginRight: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
    },
  },
  list: {
    margin: 0,
    listStyle: 'none',
    paddingLeft: 0,
  },
  listItem: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  language: {
    marginTop: theme.spacing(1),
    width: 150,
  },
}));



export default function AppFooter() {
  const classes = useStyles();

  return (
    <div id='footer'>
      <Typography component="footer" className={classes.root}>
        <Container className={classes.container}>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={4} md={3}>
              <Grid
                container
                direction="column"
                justify="flex-end"
                className={classes.iconsWrapper}
                spacing={5}
              >
                <Grid item xs={12} sm={4} md={2}>
                  <Copyright />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <Typography variant="h6" marked="left" gutterBottom>
                Telefono
              </Typography>
              <ul className={classes.list}>
                <li className={classes.listItem}>
                <Typography variant="h7" marked="left" gutterBottom>
                  0054-223-4936844
                </Typography>
                </li>
                
              </ul>
            </Grid>
            <Grid item xs={12} sm={8} md={4}>
              <Typography variant="h6" marked="left" gutterBottom>
                Domicilio
              </Typography>
              <ul className={classes.list}>
                <li className={classes.listItem}>
                  <Typography variant="h7" marked="left" gutterBottom>
                    Catamarca 2324 - Mar del Plata (7600) 
                  </Typography>
                  </li>
                <li>
                  <Typography variant="h7" marked="left" gutterBottom>
                    Buenos Aires - Argentina
                  </Typography>
                </li>
              </ul>
            </Grid>
            <Grid item  xs={12} sm={6} md={4}>
              <Typography variant="caption">
                {'Desarrollo pagina web made by '}
                <Link href="https://sarasasevillano.com.ar" rel="nofollow" title="SarasaSevillano">
                  Sarasa Sevillano
                </Link>
                {' Icons made by '}
                <Link href="https://www.freepik.com" rel="nofollow" title="Freepik">
                  Freepik
                </Link>
                {' from '}
                <Link href="https://www.flaticon.com" rel="nofollow" title="Flaticon">
                  www.flaticon.com
                </Link>
                {' is licensed by '}
                <Link
                  href="https://creativecommons.org/licenses/by/3.0/"
                  title="Creative Commons BY 3.0"
                  rel="nofollow">
                  CC 3.0 BY
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Typography>
    </div>
  );
}
